import React, { useState, useEffect } from "react";
import {
	SearchOutlined,
	CheckCircleOutlined,
	MinusCircleOutlined
} from "@ant-design/icons";
import {
	List,
	Button,
	Select,
	message,
	Input,	
	Tag,
	DatePicker,
	Checkbox,
	Col, 
	Row,
	Tooltip,
	theme,
} from "antd";
import { 
	get_invoices, 
	edit_invoice,	
} from "../services";
import ReporteExcel from "../components/reports/ExcludedReport";
import { 
	Invoice,
	MassiveInvoices, 
	AllowUserMoreOptionsSales,
	AllowedInvoicesStatesForEditSales,
	UnallowedUserForEditSales,
	AllowedInvoicesStatesForMassiveVerificationSales,
} from "../components/invoices";
import he from "he";
import dayjs from "dayjs";
import { formatNumberOfCurrency, formatShownDate, formatShownHour, reduceText } from "../utils/Formaters";

import PropTypes from "prop-types";
import { CircleAnimationCompact } from "../components/loading";
import { 
	useCalculateListSizeForPaginationHook, 
	useCalculateWindowSizeForTextLength } from "../hooks";
import { hover_item } from "../hover";
import { UserRols, InvoiceStates, InvoicesTypesColor, InvoicesTypes } from "../constants";
import { noSelectedInvoice } from "../components/invoices/utils";
import useInvoicesManager from "../components/invoices/hooks/useInvoiceManager";
import { WaitingForACompany } from "../components/WaitingForACompany";
import { Dropdown } from "antd";

const no_selected_company = {
	id: "",
	address: "",
	country: "",
	description: "",
	is_associated_company: true,
	name: "",
	accounting_resources: {
		accounting_plan: [],
		diaries: [],
		expense_accounts: [],
		sale_accounts: [],
		others:{
			analytic_accounts:[]
		}
	},
	database_id: "",
	tax_authority_specifications: {
		pequenio_contribuyente: false,
	},
	looker_link: "",
	database: undefined,
};

// const INVOICES_TYPES = {
// 	unverified: "Sin Verificar",
// 	verified: "Verificada",
// 	excluded: "Excluída",
// 	history: "Historia",
// 	canceled: "Anulada",
// 	error: "Error",
// 	notification_sent: "Notification Sent",
// 	all: "Todos",
// };

// const INVOICES_TYPES_COLORS = {
// 	unverified: "orange", // Orange
// 	verified: "green",
// 	excluded: "yellow",
// 	history: "blue",
// 	canceled: "gray",
// 	error: "red",
// 	notification_sent: "purple",
// 	all: "black",
// };

const ClientInvoiceOptions = [
	{
		value: InvoiceStates.UNVERIFIED,
		label: "Sin Verificar",
	},
	{
		value: InvoiceStates.ALL,
		label: "Todos",
	},
	{
		value: InvoiceStates.VERIFIED,
		label: "Verificada",
	},
	{
		value: InvoiceStates.EXCLUDED,
		label: "Excluída",
	},
	{
		value: InvoiceStates.CANCELED,
		label: "Anulada",
	},
];

const NormalInvoiceOptions = [
	{
		value: InvoiceStates.UNVERIFIED,
		label: "Sin Verificar",
	},
	{
		value: InvoiceStates.ALL,
		label: "Todos",
	},
	{
		value: InvoiceStates.NOTIFICATION_SENT,
		label: "Notificación Enviada",
	},
	{
		value: InvoiceStates.VERIFIED,
		label: "Verificada",
	},
	{
		value: InvoiceStates.EXCLUDED,
		label: "Excluída",
	},
	{
		value: InvoiceStates.HISTORY,
		label: "Historia",
	},
	{
		value: InvoiceStates.CANCELED,
		label: "Anulada",
	},
];

const BillingInvoiceOptions = [
	{
		value: InvoiceStates.ALL,
		label: "Todos",
	},
	{
		value: InvoiceStates.UNVERIFIED,
		label: "Sin Verificar",
	},
	{
		value: InvoiceStates.VERIFIED,
		label: "Verificada",
	},
	{
		value: InvoiceStates.CANCELED,
		label: "Anulada",
	},
];

const rangePresets = [
	{
		label: "Last 7 Days",
		value: [dayjs().add(-7, "d"), dayjs()],
	},
	{
		label: "Last 14 Days",
		value: [dayjs().add(-14, "d"), dayjs()],
	},
	{
		label: "Last 30 Days",
		value: [dayjs().add(-30, "d"), dayjs()],
	},
	{
		label: "Last 90 Days",
		value: [dayjs().add(-90, "d"), dayjs()],
	},
];

const tagColor = {
	"RECI": "black",
	"FACT": "magenta",
	"FESP": "blue"
};

const { RangePicker } = DatePicker;

const restructureInvoiceForView = (invoices) => {
	return invoices.map((invoice) => {
		return {
			...invoice,
			isLoading: false,
		};
	});
};

const POSITION = "in";
const MASSIVE_INVOICES_LIMIT = 150; // MASSIVE_INVOICES_LIMIT

export const SalesInvoices = ({ user, token, company }) => {

	const { token : antToken } = theme.useToken();

	const [loading, setLoading] = useState(false);
	const [loadingMore, setLoadingMore] = useState(false);
	const [loadingSubmit, setLoadingSubmit] = useState(false);
	const [loadingSearch, setLoadingSearch] = useState(false);

	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);	
	const [selectedState, setSelectedState] = useState(null);	

	const { pageSize } = useCalculateListSizeForPaginationHook(70);
	const { textLength: baseTextLength } = useCalculateWindowSizeForTextLength();
	const [textLength, setTextLength] = useState(baseTextLength);

	// Update textLength when selectedState changes
	useEffect(() => {
		if (selectedState === InvoiceStates.ALL) {
			// Reduce text length when showing ALL since there's an extra column
			setTextLength(baseTextLength * 0.75);
		} else {
			setTextLength(baseTextLength);
		}
	}, [selectedState, baseTextLength]);


	const [invoices, setInvoices] = useState([]);
	const [invoicesBackup, setInvoicesBackup] = useState([]);
	
	const [hoveredItem, setHoveredItem] = useState(null);
	const [selectedInvoice, setSelectedInvoice] = useState(noSelectedInvoice(POSITION));
	const [lastSelectedState, setLastSelectedState] = useState("");

	const [checkedList, setCheckedList] = useState([]);
	const checkAll = invoices.length === checkedList.length;
	const indeterminate = checkedList.length > 0 && checkedList.length < invoices.length;
	const [openMassiveInvoices, setOpenMassiveInvoices] = useState(false);
		
	const { setSelectedInvoiceSafe, onSubmitInvoiceChanges } = useInvoicesManager({
		invoices,
		invoicesBackup,
		setInvoices,
		setInvoicesBackup,
		position: POSITION,
		setSelectedInvoice,
		noSelectedInvoice,
	});
	
	const getInvoiceTags = (inv) => {
		const tags = [];

		if (inv.emission_process) {
			tags.push(
				<div>
					<Tooltip placement="top" title={"Emitida en ARO"}>
						{inv.emission_process.emitted? <CheckCircleOutlined style={{fontSize:"20px", color:"green", marginRight:"2px"}}/> : <MinusCircleOutlined style={{fontSize:"20px", marginRight:"2px"}} />}
					</Tooltip>
					<Tooltip placement="top" title={"Correo Enviado"}>
						{inv.emission_process.email_sent? <CheckCircleOutlined style={{fontSize:"20px", color:"green", marginRight:"2px"}}/> : <MinusCircleOutlined style={{fontSize:"20px", marginRight:"2px"}} />}
					</Tooltip>
					<Tooltip placement="top" title={"Enviado a ERP"}>
						{inv.emission_process.erp_sent? <CheckCircleOutlined style={{fontSize:"20px", color:"green", marginRight:"2px"}}/> : <MinusCircleOutlined style={{fontSize:"20px", marginRight:"2px"}} />}
					</Tooltip>
					<Tooltip placement="top" title={"Pagado"}>
						{inv.emission_process.payed? <CheckCircleOutlined style={{fontSize:"20px", color:"green"}}/> : <MinusCircleOutlined style={{fontSize:"20px"}} />}
					</Tooltip>
				
				</div>
			);
		}

		return tags;
	};

	/* FORMATING */

	const decodeText = (text) => {
		const decodedText = he.decode(text);
		return decodedText;
	};

	const onRangeChange = (dates, dateStrings) => {
		if (dates) {
			setStartDate(dateStrings[0]);
			// Convertir la fecha a un objeto Date, sumarle un día y convertirla de nuevo a string
			const adjustedEndDate = new Date(dateStrings[1]);
			adjustedEndDate.setDate(adjustedEndDate.getDate() + 1);
			setEndDate(adjustedEndDate.toISOString().split("T")[0]); // Formatear como YYYY-MM-DD
		} else {
			setStartDate(null);
			setEndDate(null);
		}
	};	

	const onChangeState = (value) => {
		setSelectedState(value);
	};

	const checkInitialConditions = () => {
		if (
			!company ||
			company === no_selected_company ||
			!selectedState ||
			!company.id
		) {
			message.error("No has seleccionado todos los valores");
			return false;
		}

		if(selectedState === InvoiceStates.ALL && (startDate == null || endDate == null)){
			//message.error("Por favor coloca un rango de fechas.");
			message.info("Selecciona un rango de fechas, con un máximo de 3 meses.");
			return false;
		}

		if(selectedState === InvoiceStates.ALL && startDate && endDate){
			const checkingStartDate = dayjs(new Date(startDate));
			const checkingEndDate = dayjs(new Date(endDate));

			const monthDifference = checkingEndDate.diff(checkingStartDate, "month", true);
			if (monthDifference > 3){
				message.error("El rango de fechas no puede superar los 3 meses.");
				return false;
			}
		}
		
		return true;
	};

	const formatDateSearch = (date, isEndDate) => {
		if (!date) return undefined;
		const newDate = new Date(date);
		if (isEndDate) {
			newDate.setDate(newDate.getDate() + 1);
		}
		return newDate.toISOString().split("T")[0];
	};

	const handleApiResponse = (response, stateToSearch) => {
		if (
			response === "No hay elementos" ||
			response === "No hay más elementos"
		) {
			message.info(response);
			if (response === "No hay elementos") {
				setInvoices([]);
				setInvoicesBackup([]);
			}
			return;
		}

		const uniqueNewInvoices = response.filter(
			(newInvoice) =>
				!invoicesBackup.some(
					(existingInvoice) => existingInvoice.id === newInvoice.id
				)
		);

		const newInvoices = invoicesBackup.concat(uniqueNewInvoices);

		const detectedInvoiceType =
			stateToSearch in InvoicesTypes
				? ` de tipo ${InvoicesTypes[stateToSearch]}`
				: "";
		message.success(`Se han cargado más facturas${detectedInvoiceType}`);

		setInvoices(restructureInvoiceForView(newInvoices));
		setInvoicesBackup(restructureInvoiceForView(newInvoices));
	};

	const fetchInvoices = async (lastInvoiceId) => {
		setLoading(true);

		const isNormalSearch = lastInvoiceId === undefined;

		if (isNormalSearch) {
			setLastSelectedState(selectedState);
		}

		try {
			// Search : Load More
			const stateToSearch = isNormalSearch ? selectedState : lastSelectedState;

			const response = await get_invoices(
				token,
				company.tid,
				stateToSearch,
				POSITION,
				formatDateSearch(startDate),
				formatDateSearch(endDate),
				lastInvoiceId
			);

			if (isNormalSearch) {
				setInvoices(restructureInvoiceForView(response));
				setInvoicesBackup(restructureInvoiceForView(response));
				const detectedInvoiceType =
					stateToSearch in InvoicesTypes
						? ` de tipo ${InvoicesTypes[stateToSearch]}`
						: "";
				message.success(`Se han cargado facturas${detectedInvoiceType}`);
			} else {
				handleApiResponse(response, stateToSearch);
			}
		} catch (error) {
			message.error(error.response.data);
			setLastSelectedState("");
		} finally {
			setLoading(false);
			setLoadingSearch && setLoadingSearch(false);
			setLoadingMore && setLoadingMore(false);
		}
	};

	const handleSearch = async () => {
		if (!checkInitialConditions()) return;
		setLoadingSearch(true);
		setCheckedList([]);
		fetchInvoices();
	};

	const loadMore = async () => {
		if (!invoices.length) {
			message.error("No se pueden cargar más facturas");
			return;
		}
		setLoadingMore(true);

		// Sort invoices by date and time (newest to oldest)
		const sortedInvoices = [...invoicesBackup].sort((a, b) => {
			const dateA = new Date(a.date);
			const dateB = new Date(b.date);
			return dateB - dateA; // Descending order (newest first)
		});

		// Get the id of the last invoice after sorting
		const lastInvoiceId = sortedInvoices[sortedInvoices.length - 1].id;
		fetchInvoices(lastInvoiceId);
	};

	/* SUBMIT INVOICE */
		
	const handleMassiveRestoreSubmit =  async () => {
		setLoadingSubmit(true);

		try{
			const res = await edit_invoice(token, "massive_restore", { ids: checkedList }, POSITION);
			if(res){
				message.success("Facturas incluidas de forma masiva.");
				setInvoices(invoices.filter((invoice) => !checkedList.includes(invoice.id)));
				setCheckedList([]);
				setInvoicesBackup([]);
			}
		}catch(error){
			setInvoices(invoicesBackup);
			message.error(error.response.data);
		}

		setLoadingSubmit(false);
	};

	const handleMassiveExcludeSubmit =  async () => {
		setLoadingSubmit(true);

		try{
			const res = await edit_invoice(token, "massive_exclude", { ids: checkedList }, POSITION);
			if(res){
				message.success("Facturas excluídas de forma masiva.");
				setInvoices(invoices.filter((invoice) => !checkedList.includes(invoice.id)));
				setCheckedList([]);
				setInvoicesBackup([]);
			}
		}catch(error){
			setInvoices(invoicesBackup);
			message.error(error.response.data);
		}

		setLoadingSubmit(false);
	};
		
	const handleMassiveHistorySubmit =  async () => {
		setLoadingSubmit(true);

		try{
			const res = await edit_invoice(token, "massive_history", { ids: checkedList }, POSITION);
			if(res){
				message.success("Facturas agregadas a Historia de forma masiva.");
				setInvoices(invoices.filter((invoice) => !checkedList.includes(invoice.id)));
				setCheckedList([]);
				setInvoicesBackup([]);
			}
		}catch(error){
			setInvoices(invoicesBackup);
			message.error(error.response.data);
		}

		setLoadingSubmit(false);
	};
								
	useEffect(() => {
		// // ! RECOMENDED to DECOMENT if want to debug or something like this.
		// if (process.env.NODE_ENV === "development" && invoicesBackup.length > 0) {			
		// 	console.log("Skipping clearing invoices in dev mode");
		// 	return;
		// }
		
		setInvoices([]);
		setInvoicesBackup([]);
	}, [company]);

	/* SENDING INVOICE TO MODIFY STATE */

	const actions = [
		{
			key: "1",
			label: "Verificar en Masa",
			disabled: (checkedList.length < 2) || loadingSubmit,
			loading: loadingSubmit,
			onClick: () => {
				setOpenMassiveInvoices(true);
			},
		},
		{
			key: "2",
			label: "Excluir en Masa",
			disabled: (checkedList.length < 2) || loadingSubmit,
			onClick: () => {
				handleMassiveExcludeSubmit();
			},
		},
		{
			key: "3",
			label: "Historia en Masa",
			disabled: (checkedList.length < 2) || loadingSubmit,
			onClick: () => {
				handleMassiveHistorySubmit();
			},
		}
	];
				
	/* SEARCH INVOICE */

	const onChangeSearch = (value) => {
		const text = value.target.value;

		const matchesText = (str) => {
			if (typeof str === "string") {
				return str.toLowerCase().includes(text.toLowerCase());
			}
			else if (typeof str === "number") {
				return String(str).toLowerCase().includes(text.toLowerCase());
			}
			return false;
		};

		const checkObjectForMatch = (obj) => {
			for (const key in obj) {
				if (matchesText(obj[key])) {
					return true;
				}

				if (typeof obj[key] === "object" && obj[key] !== null) {
					if (checkObjectForMatch(obj[key])) {
						return true;
					}
				}
			}
			return false;
		};

		if (text === "") {
			setInvoices(invoicesBackup);
		} else {
			const resultado = invoicesBackup.filter((invoice) =>
				checkObjectForMatch(invoice)
			);
			setInvoices(resultado);
		}
	};
	
	const onChangeAllSelect = (e) => {
		const limitedInvoices = invoices.slice(0, MASSIVE_INVOICES_LIMIT);
		setCheckedList(e.target.checked ? limitedInvoices.map((invoice_id) => invoice_id.id) : []);
	};

	const onChangeInvoiceSelected = (e, invoice_id) => {		
		if(checkedList.length > MASSIVE_INVOICES_LIMIT && e.target.checked){ // Check the limit
			message.warning(`El límite de facturas a mandar de forma masiva es de ${MASSIVE_INVOICES_LIMIT}`);
			return;
		}
		
		if(e.target.checked){ // Add Element
			setCheckedList([...checkedList, invoice_id]);
			return;
		}
		
		setCheckedList( // Remove id invoice
			checkedList.filter((checkList) => {
				return checkList !== invoice_id;
			})
		);		
	};

	const chargeInvoice = async (currentIndex, increment) => {
		const newIndex = currentIndex + increment;
		if (newIndex >= 0 && newIndex < invoices.length) {						
			onClose();

			setTimeout(() => {
				handleCompanyInvoice(invoices[newIndex]);
			}, 150);

			return;
		}
		
		onClose();
	};

	const chargeNext = () => {
		const currentIndex = invoices.findIndex(
			(invoice) => invoice.id === selectedInvoice.id
		);
		if (currentIndex !== -1) {
			chargeInvoice(currentIndex, 1);								
		}
	};

	const chargePrevious = () => {
		const currentIndex = invoices.findIndex(
			(invoice) => invoice.id === selectedInvoice.id
		);
		if (currentIndex !== -1) {
			chargeInvoice(currentIndex, -1);								
		}
	};
	
	const onClose = () => {
		setSelectedInvoiceSafe(noSelectedInvoice(POSITION));
	};

	const handleCompanyInvoice = (item) => {		
		if (item.receptor_id === company.tid || item.sender_id === company.tid) {
			setSelectedAndShowEdit(item);
		} else {
			message.error("Esta factura no es de la empresa seleccionada.");
		}
	};

	const setSelectedAndShowEdit = (item) => {
		if (selectedState === InvoiceStates.UNVERIFIED) {
			const updatedObject = {
				...item,
				accounting_specifications: {
					...item.accounting_specifications,
					in: {
						...item.accounting_specifications.in,
						accounting_date: item.date,
					},
				},
			};
			setSelectedInvoiceSafe(updatedObject);
		} else {
			setSelectedInvoiceSafe(item);
		}		
	};
		
	const updateInvoiceByIndex = (updatedInvoiceData) => {
		const currentIndex = invoices.findIndex(
			(invoice) => invoice.id === selectedInvoice.id
		);

		setSelectedInvoiceSafe({...selectedInvoice, ...updatedInvoiceData});
		
		setInvoices((prevInvoices) => {
			const updatedInvoices = [...prevInvoices];
			updatedInvoices[currentIndex] = { ...updatedInvoices[currentIndex], ...updatedInvoiceData };
			return updatedInvoices;
		});
	};
		
	return (
		<>
			<WaitingForACompany company_id={company.id}/>
			{
				company.id !== "" && 
				<>
					<Row>
						<Col
							span={4}
						>
							<Select
								placeholder="Selecciona un estado"
								optionFilterProp="children"
								onChange={onChangeState}
								filterOption={(input, option) =>
									(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
								}
								style={{
									width: "90%"
								}}
								options={	(user.role === UserRols.BILLING)? 
									BillingInvoiceOptions :
									(user.role === UserRols.CLIENT)? 
										ClientInvoiceOptions :
										NormalInvoiceOptions}
							/>
						</Col>
						<Col
							span={6}
						>
							<RangePicker
								presets={rangePresets}
								style={{
									width: "90%"
								}}
								onChange={onRangeChange}
							/>
						</Col>
						<Col
							span={2}
						>
							<Button
								style={{
									width:"90%"
								}}
								type="primary"
								loading={loadingSearch}
								onClick={() => {
									handleSearch();
								}}
							>
								Buscar
							</Button>
						</Col>
						<Col span={2}>
							{invoices.length > 0 && (
								<ReporteExcel
									data={invoices.map((element) => ({
										serie: element.reference,
										numero: element.number,
										fecha: element.date,
										moneda: element.currency,
										nombre_emisor: element.sender_name,
										nit_emisor: element.sender_id,
										nombre_establecimiento: element.establishment_name,
										nombre_receptor: element.receptor_name,
										nit_receptor: element.receptor_id,
										gran_total: element.total,
									}))}
								></ReporteExcel>
							)}

						</Col>
						<Col
							span={7}
						>
							<Input
								placeholder="Palabra Clave"
								style={{
									width:"90%",
								}}
								onChange={onChangeSearch}
								prefix={
									<SearchOutlined />
								}
							/>
						</Col>
						{((lastSelectedState === InvoiceStates.UNVERIFIED || AllowedInvoicesStatesForMassiveVerificationSales.includes(lastSelectedState)) && invoices.length > 0) &&
							<Col 
								span={3}
							>
								{lastSelectedState === InvoiceStates.UNVERIFIED && (AllowUserMoreOptionsSales.includes(user.role)) &&
											<Dropdown
												menu={{
													items: actions,
												}}
											>		
												<Button 
													disabled={(checkedList.length < 2)} 
													type="primary"
													loading={loadingSubmit}
													ghost
												>
												Acciones ({`${checkedList.length}/${invoices.length}`})
												</Button>
											</Dropdown>
								}								
								{(AllowedInvoicesStatesForMassiveVerificationSales.includes(lastSelectedState)) && (AllowUserMoreOptionsSales.includes(user.role)) &&
											<Button 
												disabled={(checkedList.length < 2)} 
												type="primary"
												style={{marginTop: "5px"}}
												onClick={handleMassiveRestoreSubmit}
												loading={loadingSubmit}
												ghost
											>
													Incluír
											</Button>
								}
							</Col>
						}
					</Row>
					{
						loading &&
							<CircleAnimationCompact />
					}
					{
						!loading &&
						<List
							header={
								<Row
									style={{
										background: antToken.colorBgLayout,
										borderRadius: antToken.borderRadius
									}}
								>
									<Col
										flex="50px"
										style={{
											display:"flex",
											justifyContent:"center"
										}}
									>
										{
											((lastSelectedState === InvoiceStates.UNVERIFIED || 
												AllowedInvoicesStatesForMassiveVerificationSales.includes(lastSelectedState) && 
												AllowUserMoreOptionsSales.includes(user.role)) &&
											<Checkbox
												indeterminate={indeterminate} 
												checked={checkAll} 
												onChange={onChangeAllSelect}
											/>)
										}
									</Col>
									<Col
										flex="auto"
									>
										<List.Item
											key={0}
										>
											<List.Item.Meta
												style={{
													maxWidth:150,
													textAlign:"center"
												}}
												title="Fecha"
												description="Hora"
											/>
											<List.Item.Meta
												title="Receptor"
												description="Establecimiento"
											/>
											<List.Item.Meta
												style={{
													maxWidth:200,
													marginRight:50,
													textAlign:"end"
												}} 
												title="Total"
												description="Total Impuestos"
											/>
											{lastSelectedState === InvoiceStates.ALL && <List.Item.Meta
												style={{
													maxWidth:150,
													textAlign:"center"
												}}
												title="Tipo de Factura"
												description=""
											/>}											
											<List.Item.Meta
												style={{
													maxWidth:150,
													textAlign:"center"
												}}
												title="Tipo de Documento"
												description=""
											/>
											<List.Item.Meta
												style={{
													maxWidth:150,
													textAlign:"center"
												}}
												title="Serie"
												description="Número"
											/>
											<List.Item.Meta
												style={{
													maxWidth:150,
													textAlign:"center"
												}}
												title="Etiquetas"
												description=""
											/>
										</List.Item>
									</Col>
								</Row>
							}
							pagination={{
								position: "top",
								align: "center",
								disabled: false,
								showSizeChanger: false,
								pageSize: pageSize,
								showTotal:(total, range) => `${range[0]}-${range[1]} de ${total} Facturas tipo ${InvoicesTypes[lastSelectedState]}`
							}}
							style={{
								textAlign: "start",
							}}
							loadMore={
								<div style={{ textAlign: "center" }}>
									<Button
										type="primary"
										style={{
											marginTop: "20px",
										}}
										loading={loadingMore}
										onClick={() => {
											loadMore();
										}}
									>
										Cargar más
									</Button>
								</div>
							}
							size="small"
							dataSource={invoices}
							renderItem={(item, index) => (
								<Row
									style={hover_item(hoveredItem === index, antToken, "invoices", 60)}
								>
									{((lastSelectedState === InvoiceStates.UNVERIFIED || AllowedInvoicesStatesForMassiveVerificationSales.includes(lastSelectedState)) && invoices.length > 0) &&
										<Col
											flex="50px"
											style={{
												display:"flex",
												justifyContent:"center"
											}}
										>
											{
												((AllowUserMoreOptionsSales.includes(user.role))) &&
												<Checkbox 										
													checked={(checkedList.find((checked) => checked === item.id) === undefined) ? false : true}
													onChange={(e) => onChangeInvoiceSelected(e, item.id)} 
												/>
											}
										</Col>
									}
									<Col flex="auto">
										<List.Item
											key={index}
											onMouseEnter={() => setHoveredItem(index)}
											onMouseLeave={() => setHoveredItem(null)}
											onClick={() => handleCompanyInvoice(item)}
										>
											<List.Item.Meta
												style={{
													maxWidth:150,
													textAlign:"center"
												}}
												title={ formatShownDate(item.date) }
												description={ formatShownHour(item.date) }
											/>
											<List.Item.Meta
												title={
													<a> 
														{reduceText(decodeText(item.receptor_name), textLength)}
													</a>
												}
												description={reduceText(decodeText(item.establishment_name), textLength)}
											/>
											<List.Item.Meta
												style={{
													maxWidth:200,
													marginRight:50,
													textAlign:"end"
												}}
												title=
													{formatNumberOfCurrency(
														item.total,
														item.currency !== "" ? item.currency : "GTQ"
													)}
												description=
													{formatNumberOfCurrency(
														item.taxes.reduce((acc, tax) => acc + tax.total, 0),
														item.currency !== "" ? item.currency : "GTQ"
													)}
											/>
											{lastSelectedState === InvoiceStates.ALL && <List.Item.Meta
												style={{
													maxWidth:150,
													textAlign:"center"
												}}
												title={
													<Tag 
														color={InvoicesTypesColor[item.accounting_specifications?.in?.state] ?? "blue"}
													>
														{InvoicesTypes[item.accounting_specifications?.in?.state]}
													</Tag>
												}
											/>}											
											<List.Item.Meta
												style={{
													maxWidth:150,
													textAlign:"center"
												}}
												title={
													<Tag color={tagColor[item.type] ?? "blue"}>{item.type}</Tag>
												}
											/>
											<List.Item.Meta
												style={{
													maxWidth:150,
													textAlign:"center"
												}}
												title={
													item.reference
												}
												description={
													item.number
												}
											/>
											<List.Item.Meta
												style={{
													maxWidth:150,
													textAlign:"center"
												}}
												title={
													getInvoiceTags(item)
												}
											/>
										</List.Item>
									</Col>																		
								</Row>
							)}
						/>
					}
					<Invoice
						// ESCENTIAL PROPERTIES
						token={token}
						open={open}
						currentInvoice={selectedInvoice}
						lastSelectedState={lastSelectedState}
						user={user}
						company={company}
						position={POSITION}
						// Filters Allowed
						AllowedInvoicesStatesForEdit={AllowedInvoicesStatesForEditSales}
						UnallowedUserForEdit={UnallowedUserForEditSales}
						// EMITION FUNCTIONS
						onUpdateItem={updateInvoiceByIndex}
						onEmitClose={onClose}
						onChargePrevious={chargePrevious}
						onChargeNext={chargeNext}
						onResetInvoices={() => setInvoices(invoicesBackup)}						
						onSubmitInvoiceChanges={onSubmitInvoiceChanges} 
					/>
					{
						(AllowUserMoreOptionsSales.includes(user.role)) &&
						<MassiveInvoices 
							token={token}
							invoices={invoices} 
							checkedList={checkedList} 
							company={company} 
							position={POSITION}
							openMassiveInvoices={openMassiveInvoices} 
							setOpenMassiveInvoices={setOpenMassiveInvoices} 
							setInvoices={setInvoices} 
							invoicesBackup={invoicesBackup} 
							setInvoicesBackup={setInvoicesBackup}
							setCheckedList={setCheckedList}
						/>
					}
				</>
			}			
		</>
	);
};

SalesInvoices.propTypes = {
	user: PropTypes.shape({
		email: PropTypes.string.isRequired,
		role: PropTypes.string.isRequired,
	}),
	token: PropTypes.string.isRequired,
	company: PropTypes.shape({
		id: PropTypes.string.isRequired,
		tid: PropTypes.string.isRequired,
		database: PropTypes.object,
		accounting_resources: PropTypes.shape({
			diaries: PropTypes.array,
			accounting_plan: PropTypes.array,
			others: PropTypes.shape({
				analytic_accounts: PropTypes.array
			}),
			expense_accounts: PropTypes.array,
			sale_accounts: PropTypes.array,
		})
	})
};
